import React from 'react';
import MembershipSummary from './MembershipSummary';
import PaymentForm from './PaymentForm';
import './MembershipPage.css';

const MembershipPage = () => {
  return (
    <div className="membership-page">
      <div className="membership-page__container">
        <div className="membership-page__scroll-wrapper">
          <div className="membership-page__left">
            <MembershipSummary />
          </div>
          <div className="membership-page__right">
            <PaymentForm />
          </div>
        </div>
      </div>
    </div>
  );
};

export default MembershipPage;
